import Icons from "../myIcon/Icons";

export default function AdminHeader({pagename}) {
  const userName = localStorage.getItem("username") || "Guest";
  return (
    <>
    <div className="header-add-category">
        <h5>admin <Icons name="arrowRight"/> {pagename.name}</h5>
        <div>
            <span>Hello! {userName}</span>
            <img src="/assets/admin-user.webp" alt="user" className="img-responsive" />
        </div>
    </div>

    <div className="header-navigation">
        <span>{pagename.innerpage}</span>
    </div>  
    </>
  )
}
